export default "__VITE_ASSET__Yd8nBzSK__"